module.exports = __webpack_public_path__ + "img/20190926152331360截图20190926152201660.2a31158d.jpg";